{
    "PageTitle_auth": "Authenticatie",
    "NAME": "Router",
    "PageTitle_presence": "Aanwezigheid",
    "PageTitle_changePassword": "Wachtwoord wijzigen",
    "PageTitle_forgotPassword": "Wachtwoord vergeten",
    "PageTitle_changeLanguage": "Taal wijzigen",
    "PageTitle_resetPassword": "Wachtwoord opnieuw instellen",
    "PageTitle_termsAndConditions": "Algemene voorwaarden",
    "PageTitle_cookiePolicy": "Cookiebeleid",
    "PageTitle_privacyPolicy": "Privacybeleid",
    "PageTitle_mfa": "Multi-factorauthenticatie",
    "PageTitle_teamsAuth": "Teams-authenticatie",
    "PageTitle_insights": "Inzichten",
    "PageTitle_crmIntegration": "CRM-integratie",
    "PageTitle_changeUserAgent": "Gebruikersagent wijzigen",
    "PageTitle_clientConfiguration": "Clientconfiguratie",
    "PageTitle_CRMConfiguration": "CRM-configuratie",
    "PageTitle_adminControl": "Beheerfuncties",
    "PageTitle_admin": "Administratie",
    "PageTitle_cme": "CME's",
    "PageTitle_status": "Status van de applicatieserver",
    "PageTitle_licences": "Licenties",
    "PageTitle_licenceManagement": "Licentiebeheer",
    "PageTitle_telsys": "Telefoonservers",
    "PageTitle_users": "Applicatiegebruikers",
    "PageTitle_partitions": "Partities",
    "PageTitle_device": "Apparaten",
    "PageTitle_agent": "Agenten",
    "PageTitle_code": "Codes",
    "PageTitle_auditTrail": "Auditspoor",
    "PageTitle_logManagement": "Logboekbeheer",
    "PageTitle_loggingSettings": "Logboekinstellingen",
    "PageTitle_telModuleStatus": "Status van de telefoonmodule",
    "PageTitle_recording": "Opname",
    "PageTitle_messages": "Berichten",
    "PageTitle_database": "Database",
    "PageTitle_directory": "Directory",
    "PageTitle_cxScore": "CX-score",
    "PageTitle_cxScore-cx-score": "CX-score",
    "PageTitle_cxScore-overview": "CX-score",
    "PageTitle_cxScore-calls": "CX-score",
    "PageTitle_cxiDashboard": "CXI-dashboard"
}